
const AccountDeletionSection = () => {
  return (
    <div className="pt-2 text-sm text-gray-600">
      <p>
        Test account holders can delete their account at: {" "}
        <a 
          href="/#/account-deletion" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-blue-600 hover:underline"
        >
          https://auroramultimedia.com/account-deletion
        </a>
      </p>
    </div>
  );
};

export default AccountDeletionSection;
